import { render, staticRenderFns } from "./fault-type.vue?vue&type=template&id=4a699d48&"
import script from "./fault-type.vue?vue&type=script&lang=js&"
export * from "./fault-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports